import apiClient from './apiClient';
import {
  SyncStatusResponse,
  StartSyncResponse,
  StartSyncErrorResponse,
  MissingProductsResponse,
} from '../types';

// Синхронизация склада ходит во внешний Prosklad и идёт долго, поэтому
// именно этим запросам общий таймаут не подходит — отключаем его точечно.
const NO_TIMEOUT = { timeout: 0 };

export const syncService = {
  // 1. Получение статуса синхронизации
  getSyncStatus: async (): Promise<SyncStatusResponse> => {
    try {
      const response = await apiClient.get<SyncStatusResponse>('/api/admin/sync/status');
      return response.data;
    } catch (error) {
      console.error('Ошибка при получении статуса синхронизации:', error);
      throw error;
    }
  },

  // 2. Запуск ручной синхронизации
  startSync: async (): Promise<StartSyncResponse | StartSyncErrorResponse> => {
    try {
      const response = await apiClient.post<StartSyncResponse>('/api/admin/sync/start', undefined, NO_TIMEOUT);
      return response.data;
    } catch (error: any) {
      // Если это ошибка с кодом 409 (Conflict) - синхронизация уже запущена
      if (error.response?.status === 409) {
        return error.response.data;
      }
      // Если это ошибка с кодом 400, возвращаем структуру ошибки
      if (error.response?.status === 400) {
        return error.response.data;
      }
      console.error('Ошибка при запуске синхронизации:', error);
      throw error;
    }
  },

  // 3. Получение товаров, которых нет в БД
  getMissingProducts: async (warehouseId: number): Promise<MissingProductsResponse> => {
    try {
      const response = await apiClient.get<MissingProductsResponse>(`/api/admin/sync/warehouse/${warehouseId}/missing-products`, NO_TIMEOUT);
      console.log('Service received response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Ошибка при получении товаров, которых нет в БД:', error);
      throw error;
    }
  },
};